import { create } from 'zustand'

interface GnbState {
  isGnbRendered: boolean
  show: () => void
  close: () => void
}

const useGnbStore = create<GnbState>((set) => ({
  isGnbRendered: false,
  show: () => set({ isGnbRendered: true }),
  close: () => set({ isGnbRendered: false }),
}))

export default useGnbStore
